import { render, staticRenderFns } from "./processChoose.vue?vue&type=template&id=7ace4b65&"
import script from "./processChoose.vue?vue&type=script&lang=js&"
export * from "./processChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports